module.exports = __webpack_public_path__ + "img/terminal1.a5d25cce.png";